import { useMutation } from "@tanstack/react-query";
import { App } from "antd";
import { handleError } from "api";
import {
  AuthApiService,
  LoginDTO,
  setAccessToken,
  setRefreshToken,
} from "features/auth";

const { login } = AuthApiService();

type UseLoginPayload = LoginDTO & { persistSession: boolean };

export const useLogin = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: UseLoginPayload) => {
      const { phone_number, password } = payload;

      return login({ phone_number, password });
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);
        message.error(uiMessage);
      },
      onSuccess: (data, variables) => {
        const { access_token, refresh_token } = data;
        const { persistSession } = variables;
        setAccessToken(access_token, persistSession);
        setRefreshToken(refresh_token, persistSession);
      },
    }
  );
};
